<app-open-parameters-atom
  *ngIf="parameters[0]?.value"
  [items]="parameters"
  [iconBackgroundColor]="iconBackgroundColor"
  [iconColor]="iconColor"
  [textColor]="textColor"
  (click)="openParameters()"
></app-open-parameters-atom>
